import { html } from "lit";
var icon_unlink_default = () => html`
  <svg stroke-fill viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.67 6.43 6.2 3" stroke-width="1.63" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.93 9.86H6.2" stroke-width="1.63" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.13 4.71V3" stroke-width="1.63" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M16.6 8.14h5.2c2.87 0 5.2 2.3 5.2 5.15a5.17 5.17 0 0 1-5.2 5.14h-5.2"
      stroke-width="1.63"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M5.59 13.48 2.52 16.5a5.1 5.1 0 0 0 0 7.27c2.03 2 5.33 2 7.36 0l3.06-3.03"
      stroke-width="1.63"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
`;
export {
  icon_unlink_default as default
};
//# sourceMappingURL=icon-unlink.js.map
